<template>
  <div>
    <v-card class="mx-auto">
      <v-card-text class="pa-5 black--text">
        <v-row v-for="(kategori, id) in schemaProgres2023" :key="id">
          <v-col v-if="!kategori.hidden" cols="12">
            <div class="font-weight-medium mb-1" style="font-size: 20px"> {{ kategori.title }} </div>
            <base-form-generator :schema="kategori.laporan" v-model="form" class="pt-4">
              <template v-slot:selection="{ field, item, index }">
                <v-chip v-if="index === 0" small color="secondary lighten-1">
                  <span class="body-1"> {{ (form[field.name] || []).length }} Subtopik dipilih </span>
                </v-chip>
              </template>
              <template v-slot:select="data">
                <v-list-item-content class="full-width">
                  <span class="body-2 font-weight-medium">Subtopik: </span> {{ data }}
                </v-list-item-content>
              </template>
            </base-form-generator>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import InstrumenProgres2023 from '../instrumen/Progres2023';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'FormProgres',
  mixins: [InstrumenProgres2023],
  components: { BaseFormGenerator },
  props: {
    masters: {
      type: Object,
      default: () => {},
    },
    info: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
    progresId: {
      type: [String, Number],
      default: '',
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    meta: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    ...mapState('koordinatorFsp', {
      instrumens: (state) => state.instrumens,
    }),
  },
  methods: {
    ...mapActions('preferensi', ['cekRekaman']),
    ...mapActions('koordinatorFsp', ['upload', 'delete']),

    reset() {
      this.$set(this, 'form', {});

      const laporan = this.$getDeepObj(this.info, 'laporan') || {};
      if (this.$isObject(laporan)) {
        for (const kategori in this.schemaProgres2023) {
          for (const sch of this.$getDeepObj(this.schemaProgres2023, `${kategori}.laporan`) || []) {
            if (sch.name && sch.name !== 'is_terlaksana') {
              this.$set(this.form, sch.name, laporan[sch.name]);
            }
          }
        }
      }

      // subtopiks
      const topiks = laporan.psp_kp_pa_koordinator_laporan_topiks || [];
      const subtopiks = topiks.map((topik) => topik.k_koordinator_subtopik_psp);
      this.$set(this.form, 'k_koordinator_subtopik_psp', subtopiks);
    },

    getValue() {
      const values = Object.assign(
        { subtopik: [] },
        {
          k_koordinator_laporan_psp: 4,
          pendampingan_tahun: this.info.pendampingan_tahun,
          pendampingan_ke: this.info.pendampingan_ke,
        },
        this.form
      );

      for (const kSubtopik of values['k_koordinator_subtopik_psp'] || []) {
        values.subtopik.push({
          k_koordinator_subtopik_psp: kSubtopik,
          k_koordinator_topik_psp: values.k_koordinator_topik_psp,
        });
      }

      delete values['k_koordinator_subtopik_psp'];

      return values;
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
